// The stats bar's "count up" option: each number runs from zero to its
// value when the bar scrolls into view, the way the HQ impact page's
// headline counts up (the same 1.1 s ease-out).
//
// A stat is a string — "1,234", "50+", "87%", "YEAR-ROUND" — so the
// first number in it is what runs and everything around it stays put.
// A value with no number in it is shown as it is. The finished frame is
// always the stat's own text, never a reformatted copy of it.
//
// Pure helpers first, with no imports, so the harness can run them in
// node; the composable needs Vue and lives in useCountUp below.

export const COUNT_UP_MS = 1100;

/** "1,234.5+" → { prefix: '', number: 1234.5, decimals: 1, grouped: true, suffix: '+' }, or null. */
export function splitNumber(text) {
    const m = /^(\D*?)(\d[\d,]*(?:\.\d+)?)([\s\S]*)$/.exec(String(text ?? ''));
    if (!m) return null;
    const raw = m[2];
    const number = Number(raw.replace(/,/g, ''));
    if (!Number.isFinite(number)) return null;
    return {
        prefix: m[1],
        number,
        decimals: raw.includes('.') ? raw.split('.')[1].length : 0,
        grouped: raw.includes(','),
        suffix: m[3],
    };
}

/** The stat's text with its number at fraction `k` (0..1) of the way. */
export function countUpText(text, k) {
    const parts = splitNumber(text);
    if (!parts || k >= 1) return String(text ?? '');
    const v = parts.number * Math.max(0, k);
    const shown = v.toLocaleString('en-US', {
        minimumFractionDigits: parts.decimals,
        maximumFractionDigits: parts.decimals,
        useGrouping: parts.grouped,
    });
    return `${parts.prefix}${shown}${parts.suffix}`;
}

/** Ease-out cubic, as the HQ overview uses. */
export const easeOut = (t) => 1 - (1 - Math.min(1, Math.max(0, t))) ** 3;
